import { mapState } from 'vuex';


import notification from '@/components/modules/notifications/notification/index.vue';

export default {
    name: 'modal',
    props: {
        displayFooter : {
            default : true,
            type : Boolean
        },
        cantclose : Boolean,
        module : String,
        path : String,
        data : {
            type : Object,
            default : () => {return {}}
        },
        events : {
            type : Object,
            default : () => {return {}}
        },
        mclass : String,
        fromtop : Boolean,
        canpip : Boolean,
        pipposition : String,
        modalid : String,
        customscroll : Boolean,
        reversedCustomScroll : Boolean,
        noswipe : Boolean,
        topmodal : Boolean
    },

    data : function(){
        
        return {
            loading : false,
            scroll : 0,
            blockclose : null,
            blockTouch : false,
            //pip : false
        }

    },

    mounted() {
    },
    
    destroyed() {
    },

    watch: {
        //$route: 'getdata'
    },

    components : {
        notification,
        
        home : () => import("@/components/modules/app/home/index.vue"),
        share : () => import("@/components/common/share/index.vue"),
        sharesocial : () => import("@/components/common/sharesocial/index.vue"),
        homesearch : () => import("@/components/modules/app/home/search/index.vue"),
        pincode : () => import("@/components/assets/pincode/index.vue"),
        explore : () => import("@/views/explore.vue"),
        fastmenu: () => import("@/components/modules/appmenu/fastmenu/index.vue"),
        htmlpage: () => import("@/components/common/htmlpage/index.vue"),
        story: () => import("@/components/modules/stories/story/index.vue"),
        storytext: () => import("@/components/modules/stories/text/index.vue"),
        playlist: () => import("@/components/modules/stories/playlist/index.vue"),
        bday: () => import("@/components/modules/profile/bday/index.vue"),
        setpicture: () => import("@/components/modules/profile/setpicture/index.vue"),
        locale: () => import("@/components/modules/profile/locale/index.vue"),
        edit: () => import("@/components/common/edit/index.vue"),
        setpayment: () => import("@/components/modules/app/payments/setpayment/index.vue"),
        cdvpayment: () => import("@/components/modules/app/payments/cdv/index.vue"),
        privacy : () => import("@/views/privacy.vue"),
        terms : () => import("@/views/terms.vue"),

        taskdata : () => import("@/components/modules/panel/moderation/taskdata/index.vue"),
        paymentinfo : () => import("@/components/modules/panel/payments/payment/index.vue"),

        partnerinfo: () => import("@/components/modules/panel/partnerinfo/index.vue"),
        articlestatic: () => import("@/components/modules/articles/static/index.vue"),

        coursecreate: () => import("@/components/modules/courses/create/index.vue"),
        catalog: () => import("@/components/modules/courses/catalog/index.vue"),


    },
 
    computed: mapState({
        auth : state => state.auth,

        pip : function(state){

            var mdl = _.find(state.modals, (modal) => {
                return modal.id == this.modalid
            })

            if(mdl) return mdl.pip || false

            return false
        },

        pipclass : function(){
            if(this.pip){
                if(this.pipposition) return 'pip pip' + this.pipposition
                return 'pip'
            }

            return ''
        },

        directionsNotification : function(){
            return {
                top : {
                    trueshold : 1,
                    distance : 100,
                    direction : 'top',
                    constraints : (e) => {
                        return this.scroll <= 0 && !this.blockTouch
                    }   
                }  
            }
        },

        directions : function(){

            if(this.noswipe){
                return {}
            }

            return {
                [this.fromtop ? 'top' : 'bottom'] : {
                    distance : 100,
                    direction : this.fromtop ? 'top' : 'bottom',
                    constraints : (e) => {
                        return this.scroll <= 0 && !this.blockTouch
                    }   
                }  
            }
        },


    }),

    methods : {
        endswipe : function(direction){

            this.close()
        },

        gotopip : function(){
            this.$store.commit('PIP_MODAL', {id : this.modalid, value : true})
        },

        changepip : function(p){

            this.$store.commit('PIP_MODAL', {id : this.modalid, value : p ? true : false})
        },

        close : function(){

            if(!this.blockclose){

                if(this.$refs['component'] && this.$refs['component'].wndclose) this.$refs['component'].wndclose()


                this.$emit('close')

            }
            else{

                this.$dialog.confirm(
                    this.$t(this.blockclose), {
                    okText: "Yes, close",
                    cancelText : 'No'
                })
        
                .then((dialog) => {
                    this.setblockclose(null)
                    this.$emit('close')
                }).catch( e => {
                    
                })

            }
        },

        closeiftop : function(e){
            //if(!this.scroll) this.close()
        },

        swipeHandler : function(e){
        },

        scrolling : function(e){
            
            this.scroll = e.target.scrollTop

            if((this.scroll > 0 && !this.reversedCustomScroll) || (this.reversedCustomScroll && this.scroll < 0)){
                this.blockTouch = true

                setTimeout(() => {
                    this.blockTouch = false
                }, 500)
            }
            
        },

        wndscrolling : function(e){
            if(!this.customscroll){
                this.scrolling(e)
            }
        },

        componentscrolling : function(e){
            if (this.customscroll){
                this.scrolling(e)
            }
        },

        setblockclose : function(text){
            this.blockclose = text
        },

        moving : function(e, h){
        },

        changeData : function(data){

            this.$store.commit('CHANGE_MODAL_DATA', {
                data, id : this.modalid
            })
            

            //this.$emit('changeData', data)
        },

        customevent : function(customevent){
            this.$emit('customevent', customevent)
        }

        /*bypath : function(){
            return require("@/components/" + this.path).default
        }*/

        
    },
}